import { useEffect, useState } from 'react';

// pipes
import { titleCasePipe } from 'shared/pipes';

// helper
import { didReceiveProduct } from 'shared/functions/did-receive-product';

// constants
import { LOOK_AT_CLOTHES } from 'modules/customers/customer-edit/constants';

const StyleInfoView = ({ title, values }) => {

    const dtClassName = ['subtitle', 'is-size-4 is-uppercase',
        values.length ? 'has-text-danger' : 'has-text-success']
        .join(' ');

    return (
        <div className="content">
            <dl>
                <dt className={dtClassName}>{title}</dt>
                {(values.length) && (
                    <div className="is-flex-mobile is-justify-content-flex-start is-flex-wrap-wrap">
                        {values.map((value) => (
                            <dd key={value}>{value}</dd>
                        ))}
                    </div>
                )}
            </dl>
        </div>
    );
}

const NotPickedStyleInfo = ({ name, data, fullData }) => {
    const title = titleCasePipe.transform(name);

    if (!fullData || !data) {
        const values = [];
        return (
            <div className="column has-text-centered is-6-mobile">
                <StyleInfoView title={title} values={values} />
            </div>
        );
    }

    // data should be an array

    let d = data;
    if (typeof (data) !== 'object') {
        d = data.split(',');
    };

    // fullData should be a string
    let fd = fullData;
    if (typeof (fullData) === 'object') {
        fd = fullData.toString();
    };

    const values = d.filter((v) => fd?.split(',').includes(v));

    return (
        <div className="column has-text-centered is-6-mobile">
            <StyleInfoView title={title} values={values} />
        </div>
    );
};

const Received = ({ received }) => {
    const spanClassName = ['tag is-large',
        !received ? 'is-success' : 'is-danger']
        .join(' ');

    const value = !received ? '🥳 Never received!' : '👿 Already received!';

    return (
        <span className={spanClassName} >
            {value}
        </span>
    );
}

const sizeMatching = ({ customerSizes, productSize }) => {
    if (productSize === 'ONESIZE') {
        return 'ONESIZE';
    }
    // customerSizes should be an array
    let custSizes = customerSizes;
    if (typeof (customerSizes) !== 'object') {
        custSizes = customerSizes.split('/');
    };

    // productSize should be a string
    let prodSize = productSize;
    if (typeof (productSize) === 'object') {
        prodSize = productSize?.toString();
    };

    const values = custSizes.filter((v) => prodSize?.split('/').includes(v)).join('/');
    return values;
}

const SizeMismatch = ({ customerSizes, productSize }) => {
    let view = '';
    const values = sizeMatching({ customerSizes, productSize });

    const spanClassName = ['tag is-large',
        !!values ? 'is-success' : 'is-danger']
        .join(' ');
    view = !!values ? `Size OK: ${values}` : `Size Warning: ${productSize}`;

    if (!customerSizes || !customerSizes.length) {
        view = 'No size for customer';
    }
    if (!productSize) {
        view = 'No size for product';
    }
    return (
        <span className={spanClassName} >
            {view}
        </span>
    );
}

const NoGoView = ({ customer, product }) => {
    const [received, getReceived] = useState(false);

    const { denim_size, shirt_size } = customer;

    const customerSizes = [];
    if (!!denim_size) {
        const denimArray = denim_size.split(',');
        customerSizes.push(...denimArray);
    }

    if (!!shirt_size) {
        const shirtArray = shirt_size.split(',');
        customerSizes.push(...shirtArray);
    }


    useEffect(() => {
        const receivedBoolean = async (customer, product) => {
            const result = await didReceiveProduct(customer, product);
            getReceived(result);

        }
        receivedBoolean(customer, product);
    }, [customer, product]);

    return (
        <>
            <div className="columns is-multiline is-mobile">
                <div className="column" >
                    <Received received={received} />
                </div>
                <div className="column" >
                    <SizeMismatch productSize={product.size} customerSizes={customerSizes} />
                </div>
            </div>
            <StyleNoGos product={product} customer={customer} />


        </>
    );
}

const StyleNoGos = ({ customer, product }) => {
    let lookAtClothes = customer.look_at_clothes;

    // lookAtClothes should be a string
    if (typeof (lookAtClothes) === 'object') {
        lookAtClothes = lookAtClothes?.toString();
    };
    let noGos = LOOK_AT_CLOTHES.filter(x => !lookAtClothes?.includes(x));

    return (
        <>
            <div className="columns is-centered is-multiline is-mobile">
                <NotPickedStyleInfo name="Colors NoGo"
                    data={product.color}
                    fullData={customer.colors_nogo} />
                <NotPickedStyleInfo name="Prints NoGo"
                    data={product.details}
                    fullData={customer.print_nogo} />
                <NotPickedStyleInfo name="Attributes NoGo"
                    data={product.attributes}
                    fullData={noGos} />
            </div>
        </>
    )
}

export { NoGoView, SizeMismatch, StyleNoGos };
